import { render, staticRenderFns } from "./ConfigLimits.vue?vue&type=template&id=186798e1&scoped=true&"
import script from "./ConfigLimits.vue?vue&type=script&lang=js&"
export * from "./ConfigLimits.vue?vue&type=script&lang=js&"
import style0 from "./ConfigLimits.vue?vue&type=style&index=0&id=186798e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186798e1",
  null
  
)

export default component.exports